var _rect, _rect2, _rect3, _path, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 63,
    viewBox: "0 0 40 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.52454,
    y: 4.85242,
    width: 25.5738,
    height: 51.1475,
    rx: 2,
    fill: "white",
    stroke: "#236AC9",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.37695,
    y: 5.70496,
    width: 23.8689,
    height: 42.623,
    rx: 1,
    fill: "#F2FAFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.1967,
    y: 4,
    width: 10.2295,
    height: 3.40984,
    rx: 1,
    fill: "#236AC9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 21.1968C3 20.6445 3.44772 20.1968 4 20.1968H27.5738C28.1261 20.1968 28.5738 20.6445 28.5738 21.1968V32.5968C28.5738 33.1491 28.1261 33.5968 27.5738 33.5968H22.059C21.2331 33.5968 20.7633 34.5412 21.2613 35.2L24.4422 39.4067C25.1204 40.3037 24.0309 41.4642 23.0929 40.844L12.3843 33.7627C12.2207 33.6545 12.0289 33.5968 11.8328 33.5968H4C3.44772 33.5968 3 33.1491 3 32.5968V21.1968Z",
    fill: "white",
    stroke: "#236AC9",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5.55737,
    y: 25.3115,
    width: 2.55738,
    height: 3.40984,
    rx: 1.27869,
    fill: "#2EA76D"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 8.96729,
    y: 25.3115,
    width: 2.55738,
    height: 3.40984,
    rx: 1.27869,
    fill: "#2EA76D"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 12.3771,
    y: 25.3115,
    width: 2.55738,
    height: 3.40984,
    rx: 1.27869,
    fill: "#2EA76D"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 15.7869,
    y: 25.3115,
    width: 2.55738,
    height: 3.40984,
    rx: 1.27869,
    fill: "#2EA76D"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 19.1967,
    y: 25.3115,
    width: 2.55738,
    height: 3.40984,
    rx: 1.27869,
    fill: "#2EA76D"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 22.6066,
    y: 25.3115,
    width: 2.55738,
    height: 3.40984,
    rx: 1.27869,
    fill: "#2EA76D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.351898c888d350f003854e81a933fa71.svg";
export { ForwardRef as ReactComponent };